import { fetchPhpEigth } from "api";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDownFilter } from "components/InputsMex/inputs";
import Page from "components/Page";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import useUsuario from "hooks/useUsuario";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import useParametrosPago from "redux/hooks/useParametrosPago";
import { PASOS_BREADCRUMBS } from "utils/constants";
import { guardarTracking } from "utils/tracking";
import Loading from "wrappers/Loading";
import useSuscriptorFunctions from "../components/useSusciptorFunctions";
import { CASUALITY } from "../constantes";
import { ModalInfo } from "./Modal";
import Tarifacion from "./Tarifacion";
import "./styles.scss";

const Resumen = ({ onValidarPago }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { fetchParametros, parametros, setCombos, ...stateParametrosPago } = useParametrosPago(
    CASUALITY.codProducto
  );
  const [showOpciones, setshowOpciones] = useState(false);
  const methods = useForm();
  const { reset, getValues } = methods;
  const qParams = useQueryParams();
  const { id } = qParams;
  const [resumen, setResumen] = useState({});
  const dataUsuario = useUsuario();
  const [datosTarifacion, setDatosTarifacion] = useState(null);
  const { addWarningToast } = useCustomToast();

  const [showModal, setShowModal] = useState(false);
  const [urlPdfCotizacion, setUrlPdfCotizacion] = useState(null);
  const [loadingTarifacion, setLoadingTarifacion] = useState(false);
  const [bloqueo, setBloqueo] = useState(false);
  const suscriptorFunctions = useSuscriptorFunctions();

  const [pagoRealizado, setPagoRealizado] = useState(false);

  const handleRegresar = () => {
    guardarTracking(
      CASUALITY.endpoints.guardarTracking,
      id || "",
      "Click atrás pantalla 3 Casuality",
      "Regresar pantalla 3",
      window.location.href
    );
    history.push(`${CASUALITY.urls.datosGenerales}?id=${id}`);
  };
  const asignacionSuscriptor = async () => {
    try {
      const Body = {
        idSuscriptor: dataUsuario.cliCodigoCore,
        idCotizacion: id,
        paso: "finSuscriptor",
      };
      console.log("cuerpo", Body);
      const responseSave = await fetchPhpEigth(CASUALITY.endpoints.asignacionSuscriptor, Body);
      if (!responseSave?.transaccion) {
        addWarningToast("Ha ocurrido un problema al recuperar la cotización");
        return history.goBack();
      }
    } catch (error) {}
  };
  const onSubmit = async () => {
    try {
      setLoading(true);
      guardarTracking(
        CASUALITY.endpoints.guardarTracking,
        id || "",
        "Click continuar en pantalla resumen",
        "Generar prepoliza",
        window.location.href
      );
      if (dataUsuario.isSuscriptor) {
        asignacionSuscriptor();
      }
      const response = await fetchPhpEigth(CASUALITY.endpoints.generarPrepoliza, {
        idCotizacion: id,
      });

      if (response?.transaccion === true) {
        //return history.push(`${CASUALITY.urls.contratante}?id=${response?.id}`);
        return history.push(`${CASUALITY.urls.facturacion}?idPoliza=${response?.id}&ramo=${CASUALITY.codProducto}&idCot=${id}`);
      }
      console.log(response);
    } catch (error) {}
    setLoading(false);
  };

  const tarifar = async ({ formaPago = "contado", idPlazo = "6", labelPlazo = "MENSUAL" }) => {
    guardarTracking(
      CASUALITY.endpoints.guardarTracking,
      id || "",
      "Click tarifar resumen",
      "Tarifacion",
      window.location.href
    );

    setLoadingTarifacion(true);
    try {
      const body = {
        idCotizacion: qParams?.id,
        formaPago,
        idPlazo,
        labelPlazo,
      };
      const response = await fetchPhpEigth(CASUALITY.endpoints.recargo, body);

      if (response?.transaccion === true) {
        setDatosTarifacion(response?.tarifacion);
        setUrlPdfCotizacion(response?.urlPdfCotizacion);
      }
      if (response?.tarifacion?.permitirEmitir === false) {
        setBloqueo(true);
        addWarningToast(response?.tarifacion?.msgError, { autoDismiss: false });
      }
    } catch (error) {}
    setLoadingTarifacion(false);
  };

  const init = useCallback(async () => {
    guardarTracking(
      CASUALITY.endpoints.guardarTracking,
      id || "",
      "Carga pantalla 3",
      "Consulta catalogo resumen",
      window.location.href
    );
    fetchParametros();
    setLoading(true);
    try {
      const [responseResumen, response] = await Promise.all([
        fetchPhpEigth(CASUALITY.endpoints.resumen, { idCotizacion: id }),
        fetchPhpEigth(CASUALITY.endpoints.tarifacion, { idCotizacion: id }),
      ]);
      const tarifacionCarrito = responseResumen.carrito?.valorTotal?.[0];
      console.log("RESUMEN: ", JSON.stringify(tarifacionCarrito));
      console.log("TARIFACION: ", JSON.stringify(response.tarifacion));

      if (response?.transaccion === true && responseResumen.transaccion === true) {
        const { redirect, link } = await suscriptorFunctions.validate(
          { ...responseResumen, pasoActual: "resumenEquivalencia" },
          dataUsuario
        );
        if (redirect) {
          return history.push(link);
        }

        setDatosTarifacion(response?.tarifacion);
        setUrlPdfCotizacion(response?.urlPdfCotizacion);

        setPagoRealizado(!!responseResumen?.pagoRealizado);

        setResumen({
          id: responseResumen?.carrito?._id,
          labelProducto: responseResumen.labelProducto,
          primaTotal: response?.tarifacion?.primaTotalFormato,
          coberturasAdicionales: [
            {
              label: responseResumen?.carrito?.carProductos?.[0]?.coberturaBasica,
              seleccionado: true,
            },
            ...responseResumen?.carrito?.carProductos?.[0]?.coberturasAdicionales,
          ],
        });
        // const datosTatifacion = responseResumen.carrito?.valorTotal?.[0];
        // if (datosTatifacion !== "contado") {
        //   console.log("CARRITO: ", datosTatifacion);
        //   await tarifar({
        //     formaPago: datosTatifacion.formaPago,
        //     idPlazo: datosTatifacion?.idPlazo,
        //     labelPlazo: datosTarifacion.labelPlazo,
        //   });
        // }

        if (response?.tarifacion?.permitirEmitir === false) {
          setBloqueo(true);
          addWarningToast(response?.tarifacion?.msgError, { autoDismiss: false });
        }
      }
    } catch (error) {}
    setLoading(false);
  }, [id, fetchParametros]);

  useEffect(() => {
    if (parametros && datosTarifacion) {
      console.log("PRUEBA: ", datosTarifacion);
      setCombos({
        formaPago: datosTarifacion?.formaPago,
        idPlazo: datosTarifacion?.idPlazo,
        setshowOpciones,
        reset: reset,
      });
    }
  }, [parametros, datosTarifacion]);

  useEffect(() => {
    if (dataUsuario.isDTC) {
      addWarningToast("Por favor, inicie sesión para continuar con la cotización");
      return history.push("/");
    }
    init();
  }, [init]);

  const onChangeFormPago = (value) => {
    if (value.onChange === "recalcular") {
      tarifar({
        idPlazo: value.id,
        formaPago: value.tipo,
        labelPlazo: value.label,
      });
    }
    setshowOpciones(value?.mostrarSubopciones);
  };
  const onChangePlazo = (value) => {
    const formaPago = getValues("formaPago");
    tarifar({
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    });
  };

  useEffect(() => {
    if (parametros && datosTarifacion) {
      setCombos({
        formaPago: datosTarifacion?.formaPago,
        idPlazo: datosTarifacion?.idPlazo,
        reset,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parametros, datosTarifacion, reset]);

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <div className='cr-content'>
          <Page>
            <BreadCurmb {...PASOS_BREADCRUMBS[CASUALITY.codProducto].breadCrumb} />
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[CASUALITY.codProducto].breadCrumbPasosCotizacion[4]}
              styleimg='height200px mr-3'
              pasos={PASOS_BREADCRUMBS[CASUALITY.codProducto]?.pasosCotizacion}
            />
            <div className='row gap-3 m-2'>
              <div className='col-md-6'>
                <div className='border p-4'>
                  <div className='col text-center m-2'>
                    <h3 className='font-mex'>¡Has elegido!</h3>

                    <div className='row justify-content-center mt-3 mb-5'>
                      <div className='col-11 col-md-8 border-mex-ap text-center py-4'>
                        <div
                          className='text-center font-20px w-100'
                          style={{
                            backgroundColor: "#C0E7F7",
                            paddingBottom: "0.5rem",
                            paddingTop: "0.3rem",
                            margin: "0 0 0 0 ",
                            paddingLeft: "0",
                            paddingRight: "0",
                          }}>
                          <h4 className='font-mex text-mex mt-2'>{resumen?.labelProducto}</h4>
                        </div>
                        <h2 className='font-mex'>{resumen?.primaTotal}</h2>
                      </div>
                    </div>

                    <div className='col-12 row d-flex flex-wrap m-0 p-0'>
                      <p
                        className='font-source-sans-regular'
                        style={{ fontSize: "20px", fontWeight: "100", textDecoration: true }}>
                        <p className='showcoberturas' onClick={() => setShowModal(true)}>
                          Ver coberturas adicionales
                        </p>
                      </p>
                    </div>
                  </div>

                  <FormProvider {...methods}>
                    <form>
                      <div className='row m-2'>
                        <div className='col-xl-6'>
                          <SimpleContainer
                            name='formaPago'
                            label='Opción de pago'
                            helpText={
                              (stateParametrosPago.loading && "Cargando formas de pago...") ||
                              ((!parametros?.formasPago || parametros?.formasPago?.length === 0) &&
                                "No tiene formas de pago configuradas")
                            }>
                            <DropDownFilter
                              name='formaPago'
                              filter={false}
                              options={parametros?.formasPago || []}
                              onChangeFn={onChangeFormPago}
                              loading={stateParametrosPago.loading}
                              // disabled={pagoRealizado || isRecalculando}
                              loadingText={stateParametrosPago?.loading && "Cargando..."}
                            />
                          </SimpleContainer>
                        </div>
                        {showOpciones && (
                          <div className='col-xl-6'>
                            <SimpleContainer label='Elije cuántos meses' name='idPlazo'>
                              <DropDownFilter
                                name='idPlazo'
                                filter={false}
                                rules={{ required: "Obligatorio" }}
                                options={parametros.plazos}
                                onChangeFn={onChangePlazo}
                                disabled={pagoRealizado || stateParametrosPago?.loading}
                                loading={stateParametrosPago?.loading}
                              />
                            </SimpleContainer>
                          </div>
                        )}
                      </div>
                    </form>
                  </FormProvider>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='border p-4 position-relative h-100 d-flex'>
                  <div className='w-100 mt-5'>
                    <Tarifacion
                      loading={loadingTarifacion}
                      datosTarifacion={datosTarifacion}
                      idCotizacion={qParams.id}
                      correo={resumen?.correo ?? ""}
                      userIsLoggedIn={!!dataUsuario?.userIsLoggedIn}
                      productoCodigoCore={CASUALITY.codProducto}
                      urlPdfCotizacion={urlPdfCotizacion}
                    />
                  </div>
                </div>
              </div>
            </div>
            <ModalInfo
              showModal={showModal}
              setShowModal={setShowModal}
              info={resumen?.coberturasAdicionales?.map((item) => ({
                titulo: item?.label,
                valor: item?.seleccionado,
              }))}
              titulo={"Coberturas adicionales"}
            />

            <div className='row justify-content-center my-5'>
              <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
                <button className='btn btn-atras-api' onClick={handleRegresar}>
                  Atrás
                </button>
              </div>
              <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
                <button
                  disabled={bloqueo}
                  className='btn btn-siguiente-api'
                  type='button'
                  onClick={methods.handleSubmit(onSubmit)}>
                  Siguiente
                </button>
              </div>
            </div>
          </Page>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default Resumen;
